<template>
  <div class="container-scroller">
    <!-- <app-top-nav></app-top-nav> -->
    <div class="container-fluid page-body-wrapper">
      <!-- <app-Left-SideBar></app-Left-SideBar> -->
      <div class="main-panel">
        <router-view></router-view>
        <!-- <app-footer></app-footer> -->
      </div>
    </div>
    <div class="chat-selector-btn-wrapper" v-if="aiAgents && aiAgents.length > 0">
      <button class="chat-selector-btn" @click="toggleChatSelector">
        <i v-if="!showChatSelector" class="fa fa-comments"></i>
        <i v-else class="fa fa-times spin"></i>
      </button>
      <transition name="fade">
        <div v-if="showChatSelector" class="chat-selector-dropup" @click.stop>
          <div class="chat-selector-header">
            <span>Select AI Agent</span>
            <button class="close-btn" @click="showChatSelector = false">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <ul class="chat-selector-list">
            <li v-for="agent in aiAgents" :key="agent.Id"
                :class="[agent.AccessType === 0 ? 'private' : 'public']"
                @click="selectAgent(agent)">
              <span class="icon">
                <i v-if="agent.AccessType === 0" class="fa fa-lock"></i>
                <i v-else class="fa-solid fa-earth-americas"></i>
              </span>
              <span>{{ agent.Name }}</span>
            </li>
          </ul>
          <div class="chat-selector-footer">
            Click on an agent to start a conversation
          </div>
        </div>
      </transition>
    </div>
    <div class="v-tour-holder">
      <v-tour
        name="welcomeTour"
        class="tour-modal-content small"
        :options="{ highlight: true }"
        :steps="steps"
        :skip="skip"
        :callbacks="myCallbacks"
      ></v-tour>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
/* import AppTopNav from './TopNavMenu.vue'
import AppLeftSideBar from './LeftSideBar.vue'
import AppFooter from './Footer.vue' */
import UserService from '../../services/user.service'
import AIAgentService from '../../services/aiAgent.service'

export default {
  name: 'AdminTemplate',
  components: {
    /* AppTopNav,
    AppLeftSideBar,
    AppFooter */
  },
  data () {
    return {
      myCallbacks: {
        onFinish: this.endTour,
        onSkip: this.skip
      },
      steps: [
        {
          target: '[data-v-step="1"]',
          header: {
            title: 'Manage your account'
          },
          content:
            'Update your profile information <br> upload photo or <br> change your password.',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="2"]',
          header: {
            title: 'Manage orders'
          },
          content:
            'View or search orders,<br> process new orders, <br>view reports etc.',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="3"]',
          header: {
            title: 'POS'
          },
          content:
            'Add products to cart and<br> place orders for your POS customer.',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="4"]',
          header: {
            title: 'Manage shopping services'
          },
          content: 'Add, edit or remove class, product, tour, rental etc. ',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="5"]',
          header: {
            title: 'CMS'
          },
          content:
            'Configure branding of site, create custom pages, and link them to self created menus. ',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="6"]',
          header: {
            title: 'Reports'
          },
          content:
            'View analysis and breakdowns of your business.',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="7"]',
          header: {
            title: 'CRM'
          },
          content:
            'Search members and view their activities.',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="8"]',
          header: {
            title: 'Tools'
          },
          content:
            'Manage survey, email manager, log, alerts, meetings notes and etc.',
          params: {
            placement: 'auto'
          }
        },
        {
          target: '[data-v-step="9"]',
          header: {
            title: 'Settings'
          },
          content:
            'Setup payment methods and manage stores, custom domain and etc.',
          params: {
            placement: 'auto'
          }
        }
      ],
      dfMessengerLoaded: false,
      aiAgentId: 'hello',
      chatTitle: 'AI Agent',
      showChatSelector: false,
      aiAgents: [],
      baseUrl: process.env.VUE_APP_BASE_URL + '/'
    }
  },
  mounted () {
    this.storeBrandingInformation()
    // this.storeCurrentUser()
    document.addEventListener('click', this.handleClickOutside)

    if (this.$store.state.auth.loggedIn) {
      // this.fetchAIAgnets()
    }
  },
  methods: {
    endTour () {
      UserService.updateAdminTour(this.$store.state.auth.UserData.Id, true).then(response => {
        if (response.data.Status) {
          console.log('Ended', this.$store.state.auth.UserData.IsLoginTourCompleted)
        }
      })
    },
    skip () {
      console.log('Skipped!!')
      this.endTour()
    },
    storeBrandingInformation () {
      if (!this.$store.state.auth.brandingInformation) {
        this.$store.dispatch('auth/fetchBrandingInformation')
      }
    },
    storeCurrentUser () {
      if (!this.$store.state.auth.UserData && this.$store.state.auth.loggedIn) {
        this.$store
          .dispatch('auth/fetchCurrentUserInformation')
          .then((response) => {
            if (!response.Status) {
              this.$router.push('/login')
            }
          })
      }
    },
    fetchAIAgnets () {
      AIAgentService.getAll().then(
        response => {
          if (response.data.Object && response.data.Object.Agnets) {
            this.aiAgents = response.data.Object.Agnets
          }
        },
        error => {
          console.log(error)
        }
      )
    },
    toggleChatSelector () {
      this.showChatSelector = !this.showChatSelector
    },
    handleClickOutside (e) {
      if (this.showChatSelector) {
        const dropup = this.$el.querySelector('.chat-selector-dropup')
        const btn = this.$el.querySelector('.chat-selector-btn')
        if (dropup && !dropup.contains(e.target) && btn && !btn.contains(e.target)) {
          this.showChatSelector = false
        }
      }
    },
    selectAgent (agent) {
      this.aiAgentId = agent.AgentId
      this.chatTitle = (agent.Name || 'AI Agent') + ' AI Agent'
      this.showChatSelector = false
    }
  }
}
</script>
<style scoped>
::v-deep .v-step {
  background-color: #2caae1 !important;
}

::v-deep .v-step__header {
  background-color: rgba(0, 151, 230, 0.2) !important;
}
.v-step-27684666 {
  transform: translate(1098px, 69px) 1;
}

.v-tour--active .v-tour-holder {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
}
df-messenger {
  z-index: 1050;
  position: fixed;
  --df-messenger-font-color: #334d5b;
  --df-messenger-font-family: Google Sans;
  --df-messenger-chat-background: #f3f6fc;
  --df-messenger-message-user-background: #5b3dd8;
  --df-messenger-message-user-font-color: #FFFFFF;
  --df-messenger-message-bot-background: #44b29d;
  --df-messenger-message-bot-font-color: #FFFFFF;
  --df-messenger-titlebar-background: #0b486a;
  --df-messenger-titlebar-font-color: #FFFFFF;
  --df-messenger-titlebar-subtitle-font-color: #FFFFFF;
  --df-messenger-titlebar-icon-width: auto;
  --df-messenger-titlebar-icon-height: 2rem;
  --df-messenger-titlebar-title-font-size: 1.5rem;
  --df-messenger-titlebar-icon-font-color: #FFFFFF;
  --df-messenger-chat-window-height: calc(90vh - 64px);
  --df-messenger-chat-window-width: 60vh;
  --df-messenger-titlebar-padding: 10px 16px;
  --df-messenger-chat-padding:16px;
  --df-messenger-input-padding:16px;
  --df-messenger-message-user-padding: 10px;
  --df-messenger-message-bot-padding: 10px;
  --df-messenger-message-feedback-icon-padding: 5px;
  --df-messenger-chat-border-radius: 10px;
  --df-messenger-chat-bubble-close-icon-size: 0px;
  --df-messenger-chat-bubble-icon-size: 0px;
  --df-messenger-chat-bubble-size: 0px;
  --df-messenger-chat-window-offset: 50px;
  bottom: 16px;
  right: 16px;
}
.chat-selector-btn-wrapper {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1100;
}
.chat-selector-btn {
  background: #0b486a;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  box-shadow: 0 2px 8px rgba(60,141,188,0.15);
  cursor: pointer;
  transition: background 0.2s;
}
.chat-selector-btn:hover {
  background: #20608c;
}
.chat-selector-dropup {
  position: absolute;
  bottom: 56px;
  right: 0;
  min-width: 235px;
  background: #fff;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  z-index: 1200;
  animation: fadeInUp 0.2s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
.chat-selector-header {
  background: #0b486a;
  color: #fff;
  font-weight: 700;
  font-size: 1rem; /* ~16px */
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.close-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  margin-left: 8px;
  padding: 0;
  line-height: 1;
}
.chat-selector-list {
  list-style: none;
  margin: 0;
  padding: 8px;
  background: #f8fafd;
  flex: 1 1 auto;
}
.chat-selector-list li {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px;
  margin: 0 0px 5px 0px;
  border-radius: 5px;
  font-size: 0.93rem;
  color: #444;
  background: #fff;
  border: 1px solid #ececec;
  cursor: pointer;
  position: relative;
  transition: background 0.28s, border-color 0.28s, transform 0.28s cubic-bezier(0.4, 0.0, 0.2, 1);
}
.chat-selector-list li:last-child {
  margin-bottom: 0;
}
.chat-selector-list li:hover {
  background: #f2f6fa;
  border-color: #0b486a;
  transform: translateX(3px);
}
.chat-selector-list li:hover::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 3px 0 0 3px;
  background: #0b486a;
}
.chat-selector-list li .icon {
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.98rem;
}
.chat-selector-footer {
  padding: 7px 12px;
  font-size: 0.85rem;
  color: #888;
  background: #f4f7fa;
  text-align: center;
  border-top: 1px solid #e0e0e0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.spin {
  display: inline-block;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(0deg);
}
.chat-selector-btn .fa-times.spin {
  transform: rotate(180deg);
}
</style>
